import API_BASE_URL from '../config';
import React, { useState, useEffect, useMemo } from 'react';
import { GLOBAL_CALCULATIONS } from './GlobalLogic';

const Articleshow = () => {
    const [articles, setArticles] = useState([]);
    const [orders, setOrders] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });
    const [isDataReady, setIsDataReady] = useState(false);

    useEffect(() => {
    const init = async () => {
        await GLOBAL_CALCULATIONS.initializeData();
        setArticles(GLOBAL_CALCULATIONS.allArticles);
        setOrders(GLOBAL_CALCULATIONS.allOrders);
        setIsDataReady(true);
    };
    init();
}, []);

    // const getarticles = () => {
    //     fetch(`${API_BASE_URL}/articleshowa`)
    //         .then(res => {
    //             if (!res.ok) throw new Error("Network response was not ok");
    //             return res.json();
    //         })
    //         .then(data => {
    //             setArticles(data);
    //         })
    //         .catch(err => console.error("Error fetching articles:", err));
    // }
    // const getorders = () => {
    //         fetch(`${API_BASE_URL}/ordershowa`)
    //             .then(res => res.json())
    //             .then(data => setOrders(data))
    //             .catch(err => console.error("Error fetching orders:", err));
    //     };

    const deleteArticle = async (id) => {
        let check = window.confirm("Are you sure you want to delete this article?");
        if (check) {
            try {
                let response = await fetch(`${API_BASE_URL}/delete-article/${id}`, {
                    method: "DELETE" 
                });
                if (response.ok) {
                    alert("Article Deleted Successfully");
                    GLOBAL_CALCULATIONS._initPromise = null;
                    await GLOBAL_CALCULATIONS.initializeData();

                    setArticles(GLOBAL_CALCULATIONS.allArticles);
                    setOrders(GLOBAL_CALCULATIONS.allOrders);
                } else {
                    alert("Failed to delete the article.");
                }
            } catch (error) {
                console.error("Delete error:", error);
                alert("Server error: Could not complete deletion.");
            }
        }
    };

    const requestSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    const sortedArticles = useMemo(() => {
        let sortableItems = [...articles];
        if (sortConfig.key !== null) {
            sortableItems.sort((a, b) => {
                let aValue, bValue;

                if (sortConfig.key === 'totalProduction') {
                    aValue = GLOBAL_CALCULATIONS.getArticleProductionPrice(a);
                    bValue = GLOBAL_CALCULATIONS.getArticleProductionPrice(b);
                } 
                else if (sortConfig.key === 'profit') {
                    const getNetProfit = (item) => {
                        const prodUnitPrice = GLOBAL_CALCULATIONS.getArticleProductionPrice(item);
                        const averages = GLOBAL_CALCULATIONS.getArticleAverages(item.name);
                        const totalRevenue = (Number(averages.avgSellingPrice) || 0) * (Number(item.orders) || 0);
                        const totalInternalCost = prodUnitPrice * (Number(item.orders) || 0);
                        return totalRevenue - totalInternalCost - (Number(item.promoCost) || 0);
                    };
                    aValue = getNetProfit(a);
                    bValue = getNetProfit(b);
                } else {
                    aValue = a[sortConfig.key] || 0;
                    bValue = b[sortConfig.key] || 0;
                }

                if (aValue < bValue) return sortConfig.direction === 'ascending' ? -1 : 1;
                if (aValue > bValue) return sortConfig.direction === 'ascending' ? 1 : -1;
                return 0;
            });
        }
        return sortableItems;
    }, [articles, sortConfig, isDataReady]);

    const filteredArticles = sortedArticles.filter(item => 
        item.name?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const getSortIcon = (key) => {
        if (sortConfig.key !== key) return <small className="text-muted" style={{fontSize: '10px'}}>↕</small>;
        return sortConfig.direction === 'ascending' ? 
            <small className="text-primary" style={{fontSize: '10px'}}>▴</small> : 
            <small className="text-primary" style={{fontSize: '10px'}}>▾</small>;
    };

    return (
        <div className="container-fluid py-5 bg-light min-vh-100">
            <div className="container">
                
                {/* PAGE HEADER */}
                <div className="row align-items-center mb-4 g-3">
                    <div className="col-md-4">
                        <h2 className="fw-bold mb-0">Article <span className="text-primary">Library</span></h2>
                        <p className="text-muted small mb-0">Analytics, Costs & Profits</p>
                    </div>
                    
                    <div className="col-md-5">
                        <div className="input-group shadow-sm">
                            <span className="input-group-text bg-white border-0">🔍</span>
                            <input 
                                type="text" 
                                className="form-control border-0 py-2" 
                                placeholder="Search by article name..." 
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>
                    </div>

                    <div className="col-md-3 text-end">
                        <a href="/addarticle" className="btn btn-primary px-4 fw-bold shadow-sm w-100 py-2">
                            + Add New Article
                        </a>
                    </div>
                </div>

                {/* STATS CARDS */}
                <div className="row mb-4 g-3">
                    <div className="col-md-3">
                        <div className="card border-0 shadow-sm bg-white">
                            <div className="card-body p-3">
                                <small className="text-muted fw-bold text-uppercase" style={{fontSize: '0.7rem'}}>Total Catalog</small>
                                <h4 className="mb-0 fw-bold text-primary">{filteredArticles.length} Articles</h4>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="card border-0 shadow-sm bg-white">
                            <div className="card-body p-3">
                                <small className="text-muted fw-bold text-uppercase" style={{fontSize: '0.7rem'}}>Total Orders</small>
                                <h4 className="mb-0 fw-bold text-success">
                                    {filteredArticles.reduce((acc, curr) => acc + (Number(curr.orders) || 0), 0)}
                                </h4>
                            </div>
                        </div>
                    </div>
                </div>

                {/* DATA TABLE CARD */}
                <div className="card border-0 shadow-sm">
                    <div className="card-body p-0">
                        <div className="table-responsive">
                            <table className="table table-hover align-middle mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th className="ps-4" style={{width: '50px'}}>#</th>
                                        <th style={{width: '80px'}}>Type</th>
                                        <th>Article Name</th>
                                        <th>Cost Breakdown</th>
                                        <th onClick={() => requestSort('promoCost')} style={{cursor: 'pointer', userSelect: 'none'}}>
                                            Promos {getSortIcon('promoCost')}
                                        </th>
                                        <th onClick={() => requestSort('totalProduction')} className="text-primary" style={{cursor: 'pointer', userSelect: 'none'}}>
                                            Production {getSortIcon('totalProduction')}
                                        </th>
                                        <th onClick={() => requestSort('orders')} className="text-success" style={{cursor: 'pointer', userSelect: 'none'}}>
                                            Orders {getSortIcon('orders')}
                                        </th>
                                        <th onClick={() => requestSort('profit')} className="text-success" style={{cursor: 'pointer', userSelect: 'none'}}>
                                            Net Profit {getSortIcon('profit')}
                                        </th>
                                        <th className="text-end pe-4">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredArticles.length > 0 ? (
                                        filteredArticles.map((item, index) => {
                                            const prodUnitPrice = GLOBAL_CALCULATIONS.getArticleProductionPrice(item);
                                            const averages = GLOBAL_CALCULATIONS.getArticleAverages(item.name);
                                            const totalRevenue = (Number(averages.avgSellingPrice)-Number(averages.avgExtraCost)-Number(averages.avgShipping) || 0) * (Number(item.orders) || 0);
                                            const totalInternalCost = prodUnitPrice * (Number(item.orders) || 0);
                                            const netProfit = totalRevenue - totalInternalCost - (Number(item.promoCost) || 0);

                                            return (
                                                <tr key={item._id}>
                                                    <td className="ps-4 text-muted">{index + 1}</td>
                                                    {/* DYNAMIC ICON LOGIC HERE */}
                                                    <td className="fs-5">
                                                        {item.articletype ? "👶" : "👤"}
                                                    </td>
                                                    <td>
                                                        <div className="fw-bold text-dark">{item.name}</div>
                                                    </td>
                                                    <td>
                                                        <div className="d-flex flex-wrap gap-1" style={{maxWidth: '220px'}}>
                                                            <span className="badge border text-dark fw-normal bg-white">F: ₹{item.fabric}</span>
                                                            <span className="badge border text-dark fw-normal bg-white">W: ₹{item.work}</span>
                                                            <span className="badge border text-dark fw-normal bg-white">S: ₹{item.stiching}</span>
                                                            <span className="badge border text-dark fw-normal bg-white">D: ₹{item.dupatta}</span>
                                                            <span className="badge border text-dark fw-normal bg-white">L: ₹{item.misc}</span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="text-muted fw-bold">₹{item.promoCost || 0}</div>
                                                        <small className="badge text-muted" style={{fontSize: '0.65rem'}}>
                                                            {item.promoCount || 0} Promos
                                                        </small>
                                                    </td>
                                                    <td>
                                                        <div className="text-primary fw-bold">₹{prodUnitPrice}</div>
                                                        <small className="text-muted" style={{fontSize: '0.7rem'}}>Per Unit</small>
                                                    </td>
                                                    <td>
                                                        <div className="fw-bold text-success">{item.orders || 0}</div>
                                                        <small className="text-muted" style={{fontSize: '0.7rem'}}>Avg Price: ₹{averages.avgSellingPrice}</small>
                                                    </td>
                                                    
                                                    <td>
                                                        <div className={`fw-bold ${netProfit >= 0 ? 'text-success' : 'text-danger'}`}>
                                                            ₹{netProfit.toLocaleString()}
                                                        </div>
                                                        <small className="text-muted" style={{fontSize: '0.7rem'}}>Total Gain</small>
                                                    </td>
                                                    <td className="text-end pe-4">
                                                        <div className="btn-group shadow-sm">
                                                            <a href={`/update-article/${item._id}`} className="btn btn-sm btn-white text-warning border">Edit</a>
                                                            <button className="btn btn-sm btn-white text-danger border" onClick={() => deleteArticle(item._id)}>Delete</button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan="9" className="text-center py-5 text-muted">
                                                No articles found.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Articleshow;
